/**
 * AGEON brand logo.
 *
 *   <AgeonLogo />                    default (teal lockup) — light backgrounds
 *   <AgeonLogo variant="white" />    white lockup — teal / dark backgrounds
 *   <AgeonLogo compact />            smaller (sidebar / header)
 *   <AgeonLogo markOnly />           compact size
 */
import ageonLogo from '../assets/logo/ageon.png';
import ageonLogoWhite from '../assets/logo/ageon_white.png';

export default function AgeonLogo({
    markOnly = false,
    compact = false,
    variant = 'default',
    className = '',
}) {
    const sizeClass = markOnly
        ? 'h-9 w-auto max-w-[120px]'
        : compact
            ? 'h-9 w-auto max-w-[200px] sm:h-10'
            : 'h-10 w-auto max-w-[220px] sm:h-11 sm:max-w-[240px]';

    const src = variant === 'white' ? ageonLogoWhite : ageonLogo;

    return (
        <div className={`flex shrink-0 items-center ${className}`}>
            <img
                src={src}
                alt="AGEON — Longevity & Recovery"
                className={`${sizeClass} object-contain object-left`}
                decoding="async"
            />
        </div>
    );
}
